import { useEffect, useState } from 'react';
import axios from 'axios';

// Iter 684 — le Devis Espagne n'apparaît (menu, pied de page, accueil, fiches) que si l'admin l'a activé et qu'une saison a des semaines
let cache = null;
let pending = null;
export const useDevisActif = () => {
  const [etat, setEtat] = useState(cache);
  useEffect(() => {
    if (cache) return;
    pending = pending || axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/devis-espagne/config`).then(r => { cache = { actif: !!r.data.actif && (r.data.semaines || []).length > 0, annee: r.data.annee, spa: r.data.spa || { actif: false }, comparatif: r.data.comparatif || null, semaines: (r.data.semaines || []).map(w => ({ id: w.id, start: w.start, end: w.end })) }; return cache; }).catch(() => { cache = { actif: false, spa: { actif: false } }; return cache; });
    pending.then(setEtat);
  }, []);
  return etat || { actif: false };
};
